import * as actionTypes from "../actionTypes";

export const initScenarios = (userCredentials) => ({
  type: actionTypes.INIT_SCENARIOS,
  payload: {
    ...userCredentials,
  },
});

export const resetSavingResult = () => ({
  type: actionTypes.RESET_SAVING_RESULT
})

export const initSubmitScenarios = (results) => ({
  type: actionTypes.INIT_SUBMIT_SCENARIOS,
  payload: results
});

export const getScenarios = () => ({
  type: actionTypes.GET_SCENARIOS,
});

export const getScenariosSuccess = (payload) => ({
  type: actionTypes.GET_SCENARIOS_SUCCESS,
  payload,
});

export const getScenariosError = (error) => ({
  type: actionTypes.GET_SCENARIOS_ERROR,
  error,
});

export const setScenarios = () => ({
  type: actionTypes.SET_SCENARIOS,
});

export const setScenariosSuccess = (payload) => ({
  type: actionTypes.SET_SCENARIOS_SUCCESS,
  payload,
});

export const setScenariosError = (error) => ({
  type: actionTypes.SET_SCENARIOS_ERROR,
  error,
});

/** @param {{ keepPrevious?: boolean }} [payload] — keepPrevious avoids clearing results while polling for async AI calculation */
export const initGetResults = (payload) => ({
  type: actionTypes.INIT_RESULTS,
  payload,
});

export const initSetResults = (results) => ({
  type: actionTypes.INIT_SET_RESULTS,
  payload: results
});

export const getResults = (payload) => ({
  type: actionTypes.GET_RESULTS,
  payload,
});

export const getResultsSuccess = (payload) => ({
  type: actionTypes.GET_RESULTS_SUCCESS,
  payload,
});

export const getResultsError = (error) => ({
  type: actionTypes.GET_RESULTS_ERROR,
  error,
});

export const setResults = () => ({
  type: actionTypes.SET_RESULTS,
});

export const setResultsSuccess = (payload) => ({
  type: actionTypes.SET_RESULTS_SUCCESS,
  payload,
});

export const setResultsError = (error) => ({
  type: actionTypes.SET_RESULTS_ERROR,
  error,
});


export const initGetRecommendationsQues = (id) => ({
  type: actionTypes.INIT_RECOMMENDATIONS_QUESTION,
  id: id
});
export const getRecommendationsQues = () => ({
  type: actionTypes.GET_RECOMMENDATIONS_QUESTION
});
export const setRecommendationsQuesSuccess = (payload) => ({
  type: actionTypes.GET_RECOMMENDATIONS_QUESTION_SUCCESS,
  payload: payload
});
export const setRecommendationsQuesError = (payload) => ({
  type: actionTypes.GET_RECOMMENDATIONS_QUESTION_ERROR,
  payload: payload
});


export const initGetResultsDetail = (payload) => ({
  type: actionTypes.INIT_RESULTS_DETAIL,
  id: payload
});
export const getResultsDetail = () => ({
  type: actionTypes.GET_RESULTS_DETAIL
});
export const getResultsDetailSuccess = (payload) => ({
  type: actionTypes.GET_RESULTS_DETAIL_SUCCESS,
  payload
});
export const getResultsDetailError = (error) => ({
  type: actionTypes.GET_RESULTS_DETAIL_ERROR,
  error
});


export const initSaveInterestedCareer = (payload) => ({
  type: actionTypes.INIT_INTERESTED_CAREER,
  payload
})
export const interestedCareer = (payload) => ({
  type: actionTypes.INTERESTED_CAREER,
  payload
})
export const saveInterestedCareerSuccess = (payload) => ({
  type: actionTypes.INTERESTED_CAREER_SUCCESS,
  payload
})
export const saveInterestedCareerError = (payload) => ({
  type: actionTypes.INTERESTED_CAREER_ERROR,
  payload
})



export const initCheckAffiliate = (results) => ({
  type: actionTypes.INIT_CHECK_AFFILIATE,
  payload: results
});

export const getCheckAffiliate = (payload) => ({
  type: actionTypes.CHECK_AFFILIATE,
  payload,
});

export const getCheckAffiliateSuccess = (payload) => ({
  type: actionTypes.CHECK_AFFILIATE_SUCCESS,
  payload,
});

export const getCheckAffiliateError = (error) => ({
  type: actionTypes.CHECK_AFFILIATE_ERROR,
  error,
});

export const getClearStateAffiliate = (error) => ({
  type: actionTypes.CLEAR_STATE_AFFILIATE,
  error,
});